"use client";
import React from "react";
import Image from "next/image";
import {
  Grid,
  IconButton,
  Box,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { useTranslations } from "next-intl";
import Avatars from "../../components/OverlappingAvatars";
import LoanDisbursedInfo from "../../components/LoanDisbursed/LoanDisbursedInfo";

const bullets = [
  { icon: IMAGES.quicktimeDark, label: "Instant Approval in 10 Minutes" },
  { icon: IMAGES.documentDark, label: "Paperless Process" },
  { icon: IMAGES.lendMoneyDark, label: "100% Digital Process" },
  { icon: IMAGES.percentageDark, label: "Competitive Interest rate" },
];

const LeftCard = () => {
  const t = useTranslations("Login");
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      p={1}
      pl={{ xs: 1, md: 6 }}
      pr={{ xs: 1, sm: 0 }}
      gap={1}
      justifyContent={"flex-start"}
    >
      <Stack spacing={2}>
        <Stack>
          <Grid container gap={1}>
            <Typography
              variant="h4"
              fontWeight={"bold"}
              color={WEB_COLORS.darkTeal}
              fontSize={{ md: "50px", xs: "24px" }}
            >
              Personal
            </Typography>
            <Typography
              variant="h4"
              fontWeight={"bold"}
              color={"#00F200"}
              fontSize={{ md: "50px", xs: "24px" }}
            >
              Loan
            </Typography>
          </Grid>
          <Typography
            variant="subtitle1"
            // fontWeight={"bold"}
            color={"#004135E5"}
            fontSize={{ md: "18px", xs: "10px" }}
          >
            Apply for an Instant Personal Loan up to
          </Typography>
          <Typography
            variant="subtitle1"
            // fontWeight={"bold"}
            color={"#004135E5"}
            fontSize={{ md: "18px", xs: "10px" }}
          >
            Rs 5 Lakh - Your safe, secure & 100% digital journey
          </Typography>
        </Stack>
      </Stack>

      <Stack gap={1}>
        <Stack direction="row" flexWrap="wrap" useFlexGap gap={2} pt={2}>
          {bullets?.map((item, index) => (
            <Box
              key={index}
              display={"flex"}
              direction="row"
              alignItems="center"
              sx={{
                border: `1px solid ${WEB_COLORS.secondary}`,
                borderRadius: "50px",
                width: "fit-content",
                px: { xs: 1, md: 2 },
                py: 1,
              }}
            >
              <Image
                src={item.icon}
                alt={item.label}
                height={isBelowMd ? 15 : 32}
                width={isBelowMd ? 15 : 32}
              />
              <Typography
                fontSize={{ xs: 10, sm: 14 }}
                color={WEB_COLORS.darkTeal}
                whiteSpace="nowrap"
              >
                {item.label}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Stack>

      {!isBelowMd && (
        <Stack>
          <Box
            display="flex"
            alignItems="center"
            // justifyContent="space-between"
            flexWrap="wrap" // allows wrapping on smaller screens
            gap={2} // spacing between components
            xs={6}
          >
            <Box flexShrink={0}>
              <Avatars />
            </Box>
            <Box>
              <LoanDisbursedInfo />
            </Box>
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

export default LeftCard;
